// extracted by mini-css-extract-plugin
module.exports = {"modal":"FiltersModal-modal-8a84","footer":"FiltersModal-footer-8a84"};